import styled from 'styled-components';
import { color, fg } from '@lendi-ui/color';
import { mb, ml, mr, mt, mx, my, px, py } from '@lendi-ui/spacing';
import { body, heading } from '@lendi-ui/typography';

export const ArticlesContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  ${px({ mobile: 'sm', desktop: 'xxs' })}
`;

export const ArticlePrimaryImage = styled.img`
  width: 100%;
  border-radius: 6px;
  @media (max-width: 48rem) {
    width: calc(100% + (var(--lendi-ui-size) * 3));
    margin: 0 calc(var(--lendi-ui-size) * -1.5);
    border-radius: 0;
  }
`;

export const ArticleWrapper = styled.div`
  max-width: 48rem;
  ${mx('auto')}
  ${mb('xl')}
  ${px({ mobile: 'md', desktop: 'xxs' })}
  ${ArticlePrimaryImage} {
    max-width: calc(100% + (var(--lendi-ui-size) * 3));
  }
  img:not(${ArticlePrimaryImage}) {
    width: 100%;
    border-radius: 6px;
  }
`;

export const ArticleCategoryLink = styled.a`
  ${mt({ mobile: 'md', desktop: 'nil' })}
  ${mb('xs')}
  text-decoration: none;
`;

export const ArticleCategory = styled.p`
  ${body({ size: 'xs', color: 'primary.500' })}
  cursor: pointer;
  text-transform: uppercase;
`;

export const ArticleTitle = styled.h1`
  ${heading({ size: 'lg' })}
  ${mt('nil')}
  ${mb('md')}
`;

export const ArticleInfo = styled.section`
  ${body({ size: 'xs' })}
  ${fg('shade.500')}
  ${mb('md')}
`;

export const AuthorInfo = styled.span`
  ${mr('xxxs')}
`;

export const AuthorName = styled.span`
  font-weight: 600;
`;

export const ReadTimeInfo = styled.span`
  ${ml('xxxs')}
`;

export const ArticleBody = styled.div`
  ${body({ size: 'md' })}
  > p:first-child {
    ${body({ size: 'lg' })}
  }
`;

export const Ul = styled.ul`
  ${px('lg')}
  border-top: 1px solid ${color('shade.100')};
  border-bottom: 1px solid ${color('shade.100')};
  > li {
    ${my('xs')}
  }
  ul {
    border: none;
  }
`;

export const Table = styled.table`
  display: block;
  overflow-x: auto;
  border-collapse: collapse;
  ${my('sm')}

  th, td {
    border-bottom: 1px solid ${color('primary.500')};
    ${py('xxs')}
    ${px('md')}
  }

  td {
    ${body({ size: 'sm', color: 'shade.700' })}
    font-weight: 400;
    text-align: center;
    vertical-align: middle;
  }

  td:first-child {
    font-weight: 600;
    text-align: left;
  }

  tr:last-child td {
    border: none;
  }

  th {
    ${body({ size: 'xs', color: 'primary.500' })}
    font-weight: 600;
    text-align: center;
    border: none;
  }

  th:first-child {
    text-align: left;
  }
`;
